/**
 * Static option lists for the Service Center email template form.
 *
 * Untranslated option lists live in constants (project rule MR-18). The
 * "Email Type" options are loaded from the API at runtime (see `useEmailTypes`)
 * and are therefore not listed here.
 */

/** Object type ("For") select. Legacy service-center context fixes this to
 *  Service Centre (objectTypeID 125); kept as a list so more types can be
 *  added without touching the form. */
export const TEMPLATE_OBJECT_TYPE_OPTIONS: { value: string; label: string }[] = [
    { value: '125', label: 'Service Centre' },
]

/** Default object type for create mode (Service Centre). */
export const DEFAULT_TEMPLATE_OBJECT_TYPE = 125

/** Legacy save-payload constants (hardcoded by the legacy form). */
export const TEMPLATE_SAVE_TEMPLATE_TYPE = 2

/**
 * Reminder section bounds (legacy: Reminder.js). The Frequency select only
 * offers "Daily" today — its translated label lives in the component body
 * (MR-18); this sentinel is the untranslated value behind it.
 */
export const REMINDER_RECURRENCE_DAILY = 1
export const RECUR_DAYS_MIN = 1
export const RECUR_DAYS_MAX = 99
export const INSTANCES_MIN = 1
export const INSTANCES_MAX = 20

/** Email types whose templates carry NLD/DRC statuses (legacy: TemplateStatus.js:23). */
export const EMAIL_TYPE_NLD = 7
export const EMAIL_TYPE_DRC = 8
